<template>
  <div v-loading="fetchingUsers">
    <div class="card mt-4">
      <div class="flex justify-between text-sm">
        <div class="group-options-select">
          <form-select-deactivated
            :usercount="deactivatedUsers.length"
            :groupcount="deactivatedGroups.length"
            @change-deactivated-type="changeDeactivatedType($event)"
          />
        </div>
        <div v-if="show">
          <deactivated-action-dropdown @select="deleteOrReactivate($event)" />
        </div>
      </div>
      {{ sortlist }}
      <div>

      <deactivated-users-table
        v-if="selectedTable == 'Deactivated Users'"
        @update-deactivated-users="getDeactivatedUsers"
        :deactivatedUsers="sortedDeactivatedUser"
        @refetch-users="onDeleteUser()"
        :fetchingUsers="fetchingUsers"
        ref="deactivatedUsers"
      />
      <deactivated-groups-table
        v-if="selectedTable == 'Deactivated Groups'"
        :deactivatedGroups="sortedDeactivatedUser"
        @show-delete-modal="showDeleteModal($event)"
        @update-deactivated-groups="getDeactivatedGroups"
        :fetchingGroups="fetchingGroups"
        ref="deactivatedGroups"
      />
      </div>
    </div>
  </div>
</template>

<script>
import FormSelectDeactivated from "../FormSelectDeactivated";
import DeactivatedUsersTable from "../DeactivatedUsersTable";
import DeactivatedGroupsTable from "../DeactivatedGroupsTable";
// import DeleteModal from "@/components/UI/Modal/DeleteModal";

import DeactivatedActionDropdown from "../DeactivatedActionDropdown";

export default {
  components: {
    FormSelectDeactivated,
    DeactivatedUsersTable,
    DeactivatedGroupsTable,
    // DeleteModal,
    DeactivatedActionDropdown,
  },
  props: ["queryString"],
  data() {
    return {
      selectedRowId: null,
      selectedTable: "Deactivated Users",
      options: [
        { name: "Deactivated Users", total: 0 },
        { name: "Deactivated Groups", total: 0 },
      ],
      deactivateOptions: ["Delete Selected", "Deactivate Selected"],
      deactivatedUsers: [],
      deactivatedGroups: [],
      isDeleteModal: false,
      itemToDelete: "",
      deletingItem: false,
      selectedId: "",
      fetchingGroups: true,
      fetchingUsers: true,
      // queryString: "",
    };
  },
  computed: {
    filteredDeactivatedGroups() {
      return this.filterArray(this.deactivatedGroups, this.queryString);
    },
    filteredDeactivatedUsers() {
      return this.filterArray(this.deactivatedUsers, this.queryString);
    },
    sortList() {
      return this.$store.getters.getUserAndGroupSortList;
    },
    sortedDeactivatedUser() {
      let array = [];
      switch (this.selectedTable) {
        case "Deactivated Users":
          array = this.sortList
            ? this.sortListASC(this.filteredDeactivatedUsers)
            : this.sortListDESC(this.filteredDeactivatedUsers);
          break;

        case "Deactivated Groups":
          array = this.sortList
            ? this.sortListASC(this.filteredDeactivatedGroups)
            : this.sortListDESC(this.filteredDeactivatedGroups);
          break;
      }
      console.log(array);
      return array;
    },
  },
  mounted() {
    this.getDeactivatedUsers();
    // this.getDeactivatedGroups();
    this.$on("change-deactivated-type", (e) => {
      alert(e);
      this.selectedTable = e;
    });
  },

  methods: {
    sortListASC(val) {
      return val
    },
    sortListDESC(val) {
      return val
        .map((l) => l)
        .sort((a, b) => {
          var x = a.firstname.toLowerCase();
          var y = b.firstname.toLowerCase();
          return x > y ? -1 : x < y ? 1 : 0;
        });
    },
    async getDeactivatedUsers() {
      this.fetchingUsers = true;
      try {
        let orgId = localStorage.getItem("organizationId");
        console.log(orgId);
        let response = await this.$_getDeactivatedUsers(orgId);
        console.log(JSON.stringify(response.data.data.users, null, 2));
        this.deactivatedUsers = response.data.data.users;
        this.options[0].total = this.deactivatedUsers.length;
        this.fetchingUsers = false;
      } catch (error) {
        this.handleError(error);
        this.fetchingUsers = false;
      }
    },
    // async getDeactivatedGroups() {
    //   this.fetchingGroups = true;
    //   try {
    //     let response = await this.$_getDeactivatedGroups();
    //     console.log(response);
    //     this.deactivatedGroups = response.data.groups;
    //     this.options[1].total = this.deactivatedGroups.length;
    //     this.fetchingGroups = false;
    //   } catch (error) {
    //     this.handleError(error);
    //     this.fetchingGroups = false;
    //   }
    // },
    deleteOrReactivate(selectedOption) {
      if (selectedOption == "Delete") {
        if (this.selectedTable == "Deactivated Users") {
          this.$refs.deactivatedUsers.deleteMultipleUsers();
        } else {
          this.$refs.deactivatedGroups.deleteMultipleGroups();
        }
      } else {
        if (this.selectedTable == "Deactivated Users") {
          this.$refs.deactivatedUsers.reactivateMultipleUsers();
        } else {
          this.$refs.deactivatedGroups.reactivateMultipleGroups();
        }
      }
    },
    showDeleteModal(payload) {
      this.itemToDelete = payload[0];
      this.selectedId = payload[1];
      this.isDeleteModal = true;
    },
    async deleteUser() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteUser(this.selectedId);
        this.onDeleteUser(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteGroup() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteGroup(this.selectedId);
        this.onDeleteGroup(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    onDeleteUser(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.getDeactivatedUsers();
      this.generateToast("User successfully deleted!", "success");
    },
    onDeleteGroup(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.getDeactivatedGroups();
      this.generateToast("Group successfully deleted!", "success");
    },
    deleteItem() {
      if (this.itemToDelete == "User") {
        this.deleteUser();
      } else if (this.itemToDelete == "Group") {
        this.deleteGroup();
      }
    },
    saveInput(option) {
      this.selectedTable = option;
    },
    changeDeactivatedType(type) {
      this.selectedTable = type;
      console.log("click", type);
    },
  },
};
</script>

<style scoped>
/* table { border-collapse: separate; } */
td {
  border: solid 1px #000;
}
tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
.table__search-input-wrapper {
  background: #7b858f10;
  width: 20vw;
}
/* th,
td {
  padding: 0.75rem 0.25rem;
}
td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
}
th {
  font-size: 0.7rem;
  font-weight: 600;
  min-width: 8rem;
}
th.checkbox,
th.actions {
  min-width: 3rem;
} */
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
